import styled, { css } from 'styled-components';

import { ThemeProp, WithTheme } from '../../../../../../theme/Themes';
import { drawerTransitionDuration } from '../../../BaseDrawerLayout/BaseDrawerLayout.styles';
import {
  getIconStroke,
  navigationItemBorderRadius,
  NavigationItemProps,
} from '../AppDrawerContent/AppDrawerContent.styles';

type NavigationButtonProps = NavigationItemProps;

export const IconContainer = styled.span``;
export const TextContainer = styled.div<NavigationItemProps>`
  opacity: ${(props: NavigationItemProps) => (props.$drawerIsOpen ? 1 : 0)};
  transition: opacity ${drawerTransitionDuration};
  line-height: 1.25rem;
  white-space: nowrap;
  padding-left: 0.125rem;
`;

const navigationItemCommonStyles = css`
  background: transparent;
  width: 100%;
  color: ${({ $drawerIsOpen, theme }: ThemeProp & NavigationItemProps) => getIconStroke(false, $drawerIsOpen, theme)};
  border-radius: ${navigationItemBorderRadius};

  &:hover {
    background: ${({ theme }: ThemeProp) => theme.colors.primary.c900};
  }

  &:focus {
    background: transparent;
  }
`;

export const StyledNavigationButton = styled.div<NavigationButtonProps>`
  ${navigationItemCommonStyles};
  position: relative;
  font-size: 0.875rem;
  font-weight: var(--nextui-fontWeights-normal);
  padding: 0.5rem 0.75rem;
  justify-content: flex-start;
  display: flex;
  align-items: center;
  transition: padding ${drawerTransitionDuration};

  ${TextContainer} {
  }

  ${IconContainer} {
    margin-right: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: inherit;
    z-index: var(--nextui-zIndices-1);

    svg,
    path,
    circle,
    rect {
      stroke: ${({ $drawerIsOpen, theme }: WithTheme<NavigationButtonProps>) =>
        getIconStroke(false, $drawerIsOpen, theme)};
    }
  }
`;

interface StyledNavLinkProps {
  $isActive: boolean;
}

export const StyledNavLink = styled.div<StyledNavLinkProps>`
  width: 100%;
  cursor: pointer;

  ${TextContainer} {
    font-weight: ${({ theme }: ThemeProp) => theme.fontWeight.medium};
  }

  &:hover {
    ${(props: StyledNavLinkProps) =>
      props.$isActive
        ? css`
            ${StyledNavigationButton} {
              background: ${({ theme }: ThemeProp) => theme.colors.main.c050};
            }
          `
        : css`
            ${StyledNavigationButton} {
              background: ${({ theme }: ThemeProp) => theme.colors.main.c050};
            }
          `}
  }

  ${(props: StyledNavLinkProps) =>
    props.$isActive
      ? css`
          ${StyledNavigationButton} {
            color: ${({ $drawerIsOpen, theme }: WithTheme<NavigationButtonProps>) =>
              getIconStroke(true, $drawerIsOpen, theme)} !important;

            background: ${({ theme }: ThemeProp) => theme.colors.main.c050};

            ${IconContainer} {
              svg,
              path,
              circle,
              rect {
                stroke: ${({ $drawerIsOpen, theme }: WithTheme<NavigationButtonProps>) =>
                  getIconStroke(true, $drawerIsOpen, theme)} !important;
              }
            }
          }
        `
      : null};

  &:not(:last-of-type) {
    margin-bottom: 0.25rem;
  }
`;
